import { render, staticRenderFns } from "./CardInformacoesTitulo.vue?vue&type=template&id=63aa39a6"
import script from "./CardInformacoesTitulo.vue?vue&type=script&lang=js"
export * from "./CardInformacoesTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63aa39a6')) {
      api.createRecord('63aa39a6', component.options)
    } else {
      api.reload('63aa39a6', component.options)
    }
    module.hot.accept("./CardInformacoesTitulo.vue?vue&type=template&id=63aa39a6", function () {
      api.rerender('63aa39a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardInformacoesTitulo.vue"
export default component.exports